import React from 'react'
// import LargeLogo from "../../assets/images/logos/large-logo.webp";

function Index() {
  return (
    <div className='loader w-100 vh-100 flex-column'>
      {/* <img src={LargeLogo} className="custom_animation img-fluid" alt="" width={200} /> */}
      <p>loading....</p>
    </div>
  )
}
export default Index
